Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Wikipedia", {
  enumerable: true,
  get: function get() {
    return _wikipedia.Wikipedia;
  }
});
var _wikipedia = require("./wikipedia");